import { getMetadataFieldValue } from '../utils';
import {
  DEAKIN_FUNNELBACK_AUTOCOMPLETE_CONNECTOR,
  DEAKIN_FUNNELBACK_SEARCH_CONNECTOR,
} from './deakin-config';

/** Production Matrix REST connector URLs (Pattern B). */
export const DEAKIN_FUNNELBACK_SEARCH_CONNECTOR_URL =
  DEAKIN_FUNNELBACK_SEARCH_CONNECTOR;

export const DEAKIN_FUNNELBACK_AUTOCOMPLETE_CONNECTOR_URL =
  DEAKIN_FUNNELBACK_AUTOCOMPLETE_CONNECTOR;

/** Local dev search proxy → production/staging connector. */
export const LOCAL_FUNNELBACK_SEARCH_URL = 'http://localhost:4000/__funnelback';

/** Local dev suggest proxy → production/staging connector. */
export const LOCAL_FUNNELBACK_SUGGEST_URL =
  'http://localhost:4000/__funnelback-suggest';

function trimBase(funnelbackUrl: string): string {
  return funnelbackUrl.trim().replace(/\/$/, '');
}

/** Page meta `funnelbackSearchUrl` is the full search endpoint — no `/s/search.json` suffix. */
export function resolveFunnelbackLookupBaseUrl(funnelbackUrl: string): string {
  return trimBase(funnelbackUrl);
}

/** Read search and suggest connector URLs from page meta tags. */
export function resolveFunnelbackUrlsFromMeta(
  getMeta: (field: string) => string = getMetadataFieldValue,
): { lookupBaseUrl: string; suggestBaseUrl: string } {
  return {
    lookupBaseUrl: resolveFunnelbackLookupBaseUrl(
      getMeta('funnelbackSearchUrl'),
    ),
    suggestBaseUrl: resolveFunnelbackLookupBaseUrl(
      getMeta('funnelbackSuggestUrl'),
    ),
  };
}

/** Local dev `<head>` meta tags mirroring production connector URLs. */
export function localFunnelbackConnectorMeta(): string {
  return `
    <meta name="funnelbackSearchUrl" content="${LOCAL_FUNNELBACK_SEARCH_URL}">
    <meta name="funnelbackSuggestUrl" content="${LOCAL_FUNNELBACK_SUGGEST_URL}">
  `;
}
